import { useState, useEffect, useRef } from "react";

const shallowEqual = (a, b) => {
  const aKeys = Object.keys(a || {});
  const bKeys = Object.keys(b || {});
  if (aKeys.length !== bKeys.length) return false;
  for (let key of aKeys) {
    if (a[key] !== b[key]) return false;
  }
  return true;
};

const validate = (data = {}) => {
  const errs = {};
  if (data.nif && !/^\d{9}$/.test(data.nif)) errs.nif = "NIF must have exactly 9 numbers";
  if (data.iban && data.iban.length !== 25) errs.iban = "IBAN must have exactly 25 characters";
  if (data.cc && !/^\d{9}$/.test(data.cc)) errs.cc = "CC must have exactly 9 numbers";
  if (data.social_security_number && !/^\d{9}$/.test(data.social_security_number)) errs.social_security_number = "NISS must have exactly 9 numbers";
  return errs;
};

const useUserForm = (initialData = {}, delegations = [], managers = []) => {
  const [form, setForm] = useState(initialData);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const initialRef = useRef(initialData);

  useEffect(() => {
    if (!shallowEqual(initialData, initialRef.current)) {
      setForm(initialData);
      setErrors({});
      setTouched({});
      initialRef.current = initialData;
    }
  }, [initialData]);

  useEffect(() => {
    setErrors(validate(form));
  }, [form]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));

    if (name === "nif" || name === "cc" || name === "social_security_number") {
      const digits = value.replace(/\D/g, "").slice(0, 9);
      setForm((prev) => ({ ...prev, [name]: digits }));
      return;
    }
    if (name === "iban") {
      const iban = value.replace(/[^A-Z0-9]/gi, "").toUpperCase().slice(0, 25);
      setForm((prev) => ({ ...prev, iban }));
      return;
    }
    setForm((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : name === "delegation_id" || name === "role_id" || name === "manager_id"
            ? value === "" ? null : value
            : value,
    }));
  };

  const isChanged = !shallowEqual(form, initialRef.current);
  const isValid = Object.keys(errors).length === 0 && isChanged;

  return {
    form,
    setForm,
    errors,
    setErrors,
    validate,
    handleInputChange,
    isValid,
    delegations,
    managers,
    touched,
  };
};

export default useUserForm;
